/**
 * by wrl
 */
class DeviceInfo{
    constructor(){
        this.OS = this.getOS() || "other"; //系统版本号 
        this.Device = this.getDevice();//设备
    }
    getOS() {  //判断所处操作系统
        var sUserAgent = navigator.userAgent.toLowerCase();
        var isWin = (navigator.platform == "Win32") || (navigator.platform == "Win64")|| (navigator.platform == "wow64");   
        var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");   
        var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) == "android";  
        if (isMac) return "apple";   
        if(bIsAndroid) return "android";  
        if (isWin) {   
            return "windows"
        }  
        return "other";
    }
    getDevice (){
        var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
        if (isAndroid || isPhone) {   
            // 手机
            return 'phone'
        } else if (isTablet) {
            // 平板
            return 'ipad'
        } 
        return 'pc'
    }
}
export default DeviceInfo;